module.exports = __webpack_public_path__ + "img/stonesize-1.4659415.webp";